<template>
  <div class="pageFilterComponent">
    <b-card class="mb-2" body-class="py-2 px-3">
      <div class="d-flex flex-wrap align-items-center mb-2">
        <b-form-checkbox class="mr-3 mb-1" v-model="filters.isAllDomains">
          Tous les domaines
        </b-form-checkbox>
        <b-form-checkbox class="mr-3 mb-1" v-model="filters.isModifAnnuelle">
          Change chaque année
        </b-form-checkbox>
        <b-form-checkbox class="mr-3 mb-1" v-model="filters.forceSelenium">
          Force Selenium
        </b-form-checkbox>
        <b-form-checkbox class="mr-3 mb-1" v-model="filters.hasBug">
          Bugs
        </b-form-checkbox>
        <b-form-checkbox class="mb-1" v-model="filters.hasLenteurs">
          Lenteurs
        </b-form-checkbox>
      </div>

      <div class="mb-2">
        <vue-multiselect-input
          v-model="filters.selectedRequetes"
          :options="allRequetes"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          placeholder="Filtrer par requête(s)..."
          label="name"
          track-by="id"
          :show-labels="false"
          select-label=""
          deselect-label=""
        />
      </div>

      <div class="row no-gutters mb-2">
        <div class="col-6 pr-1">
          <b-form-datepicker
            v-model="filters.updatedAfter"
            locale="fr"
            size="sm"
            placeholder="Modifié depuis"
            reset-button
            :reset-value="''"
          />
        </div>
        <div class="col-6 pl-1">
          <b-form-datepicker
            v-model="filters.updatedBefore"
            locale="fr"
            size="sm"
            placeholder="Modifié jusqu'au"
            reset-button
            :reset-value="''"
          />
        </div>
      </div>

      <div class="d-flex align-items-center flex-wrap">
        <b-button size="sm" variant="primary" class="mr-2" @click="applyFilters">
          Filtrer
        </b-button>
        <b-button
          v-if="storeIsActive"
          size="sm"
          variant="link"
          class="mr-3 p-0 text-danger"
          @click="resetFilters"
        >
          Réinitialiser
        </b-button>
        <span v-if="isLoadingStats" class="text-muted">
          <b-spinner small variant="secondary" class="mr-1" />
        </span>
        <span v-else>
          <b-badge variant="secondary" class="mr-1 stats-badge">{{ nbFolders }} dossier{{ nbFolders !== 1 ? 's' : '' }}</b-badge>
          <b-badge variant="primary" class="mr-1 stats-badge">{{ nbPages }} page{{ nbPages !== 1 ? 's' : '' }}</b-badge>
          <b-badge variant="danger" class="stats-badge">{{ nbCrawlpages }} crawlpage{{ nbCrawlpages !== 1 ? 's' : '' }} non lue{{ nbCrawlpages !== 1 ? 's' : '' }}</b-badge>
        </span>
      </div>
    </b-card>
  </div>
</template>

<script>
import { APIPage } from '@/api/APIPage'
import { APIRequete } from '@/api/APIRequete'
const apiPage = new APIPage()
const apiRequete = new APIRequete()

export default {
  name: 'pageFilterComponent',
  data() {
    return {
      filters: {
        isAllDomains: false,
        isModifAnnuelle: false,
        forceSelenium: false,
        hasBug: false,
        hasLenteurs: false,
        updatedAfter: '',
        updatedBefore: '',
        requeteIds: [],
        selectedRequetes: [],
      },
      allRequetes: [],
      nbPages: 0,
      nbFolders: 0,
      nbCrawlpages: 0,
      isLoadingStats: false,
    }
  },
  computed: {
    token() {
      return this.$store.state.auth.token
    },
    storeFilters() {
      return this.$store.state.pageFilters
    },
    storeIsActive() {
      const f = this.storeFilters
      return f.isAllDomains || f.isModifAnnuelle || f.forceSelenium || f.hasBug || f.hasLenteurs || !!f.updatedAfter || !!f.updatedBefore || (f.requeteIds && f.requeteIds.length > 0)
    },
  },
  watch: {
    storeFilters: {
      deep: true,
      immediate: true,
      handler(val) {
        this.filters = {
          ...val,
          selectedRequetes: this.allRequetes.filter(r => (val.requeteIds || []).includes(r.id)),
        }
        this.fetchStats(val)
      },
    },
    allRequetes(requetes) {
      // Once requêtes are loaded, sync selectedRequetes from store
      const ids = this.storeFilters.requeteIds || []
      this.filters.selectedRequetes = requetes.filter(r => ids.includes(r.id))
    },
  },
  created() {
    apiRequete.getAllRequetes(this.token)
      .then(result => { this.allRequetes = result.data })
      .catch(() => {})
  },
  methods: {
    applyFilters() {
      const { selectedRequetes, ...rest } = this.filters
      this.$store.commit('SET_PAGE_FILTERS', {
        ...rest,
        requeteIds: (selectedRequetes || []).map(r => r.id),
      })
    },
    resetFilters() {
      this.$store.commit('RESET_PAGE_FILTERS')
    },
    fetchStats(filtersToUse) {
      this.isLoadingStats = true
      apiPage.getGlobalStatistics(this.token, filtersToUse || this.storeFilters)
        .then((result) => {
          this.nbPages = result.data.nb_pages
          this.nbFolders = result.data.nb_folders
          this.nbCrawlpages = result.data.nb_crawlpages
        })
        .catch(() => {})
        .finally(() => {
          this.isLoadingStats = false
        })
    },
  },
}
</script>

<style scoped>
.stats-badge {
  font-size: 0.85rem;
  padding: 0.35em 0.65em;
}
</style>
